






import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type Data = {
	ID: number,
	DMSTEXT_ID: number,
	ZL_PRP_ZKT: boolean,
	ZAKAZKA_PRP_ZKT: boolean,
	PNV_PRP_ZKT: boolean,
	POV_PRP_ZKT: boolean,
	SKLADPNEU_PRP_ZKT: boolean,
	NVSPRDN_PRP_ZKT: boolean,
	NVSZAVD_PRP_ZKT: boolean,
	OPRAVADOKLAD_PRP_ZKT: boolean,
	POLOZKA_TEXT: string,
	POZNAMKA: string,
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'DMSTEXT_ID' },
		showLabel: { type: Boolean, default: true },
		dmsText: { validator: (prop) => typeof prop === 'string' || prop === null, required: true },
		inputDisabled: { type: Boolean, default: undefined },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				value: null,
				text: null,
			},
		};
	},
	computed: {
		textCmp: {
			get() {
				return this.dmsText;
			},
			set(val) {
				this.$emit('update:dmsText', val);
			},
		},
		inputDisabledCmp() {
			return this.isDisabled || this.inputDisabled;
		},
	},
	methods: {
		dbToBaseMapper(data: Data) {
			return {
				value: data.DMSTEXT_ID,
				text: data.POLOZKA_TEXT,
			};
		},
	},
});
